export default __webpack_public_path__ + "static/media/warning--divided-highway-ends--g2.d64d1f97.png";